/* eslint-disable max-len */
/* eslint-disable vue/max-len */

import * as pbm from '@/grpc-gen/marketing_campaign_settings_pb';
import * as pbs from '@/grpc-gen/marketing_campaign_manager_service_pb';

import ContactFilter from './contact-filter';

export interface MarketingCampaignMapping {
  marketingCampaignManagerContactFilters: ContactFilter[];
}

export default class MarketingCampaignSettings {
  allowedMessages: number = 0;

  createdMessages: number = 0;

  dateQuotaReset: Date = new Date();

  static fromGrpcModel(o?: pbm.MarketingCampaignSettings, m = undefined): MarketingCampaignSettings {
    const mcs = new MarketingCampaignSettings();

    mcs.allowedMessages = Number(o?.allowedMessages ?? 0);
    mcs.createdMessages = Number(o?.createdMessages ?? 0);
    mcs.dateQuotaReset = o ? new Date(Number(o.dtQuotaReset) * 1000) : new Date();

    return mcs;
  }

  static fromGrpcResponse(r: pbs.MarketingCampaignSettingsResponse): MarketingCampaignSettings {
    return MarketingCampaignSettings.fromGrpcModel(r.settings);
  }
}
